import { AsteraPrimaryCareSubmissionDataKeys } from "../hooks/useAsteraPrimaryCareSubmissionData";

export const getRouteViaStateUpdate = (
  routeVia: string,
): Record<string, string> => ({
  [AsteraPrimaryCareSubmissionDataKeys.ROUTE_VIA]: routeVia,
});
